export interface ReindexJobStartResponse {
  message: string;
}

export enum JobStatus {
  NotStarted = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  Canceled = 4,
}

export interface JobProgress {
  totalItems: number;
  processedItems: number;
  currentStep: string;
  percentageComplete: number;
}

export interface JobError {
  message: string;
  details?: string;
  timestamp: string;
}

export interface FailedDocument {
  id: string;
  type: string;
  name: string;
  error: string;
  timestamp: string;
}

export interface SearchActivity {
  timestamp: string;
  action: string;
  itemsCount: number;
  details: string;
}

export type JobActivity = SearchActivity;

export interface JobDetails {
  id: string;
  jobType: string;
  status: number;
  startTime: string;
  endTime?: string;
  errorMessage?: string;
  progress: JobProgress;
  failedDocuments: FailedDocument[];
  searchActivities: SearchActivity[];
  triggeredByUserId: string;
}

export interface JobStatusResponse extends JobDetails {
  isJobRunning?: boolean;
}

export function withComputedProps(job: JobDetails): JobStatusResponse {
  return {
    ...job,
    isJobRunning: job.status === JobStatus.Running,
  };
}

export interface JobHistoryItem {
  id: string;
  jobType: string;
  status: number;
  startTime: string;
  endTime?: string;
  errorMessage?: string;
  duration?: string;
  progress?: JobProgress;
  failedDocuments?: FailedDocument[];
  searchActivities?: SearchActivity[];
  triggeredByUserId?: string;
  errorCount?: number;
}

export type JobHistoryResponse = JobHistoryItem[];
